export const formatFileSize = (fileSize: number) => {
  const unitType = ['B', 'kB', 'MB', 'GB', 'TB'];
  const unitValue = 1024;

  const unitPrefix =
    fileSize === 0 ? 0 : Math.floor(Math.log(fileSize) / Math.log(unitValue));

  const parsedFileSize = fileSize / Math.pow(unitValue, unitPrefix);
  const resultString = parsedFileSize.toFixed(1) + ' ' + unitType[unitPrefix];

  return resultString;
};
